import {
  animate,
  animateChild,
  query,
  stagger,
  style,
  transition,
  trigger,
} from '@angular/animations';

// NOTE: This is not being used and kept it for reference.
export const itemsTrigger = trigger('items', [
  transition(':enter', [
    style({
      transform: 'scale(0.5)',
      opacity: 0,
      maxHeight: 0,
      marginBottom: 0,
    }),
    animate(
      '1s cubic-bezier(.8, -0.6, 0.2, 1.5)',
      style({
        transform: 'scale(1)',
        opacity: 1,
        maxHeight: '12rem',
        marginBottom: '*',
      })
    ),
  ]),
  transition(':leave', [
    style({
      transform: 'scale(1)',
      opacity: 1,
      maxHeight: '12rem',
      marginBottom: '*',
    }),
    animate(
      '1s cubic-bezier(.8, -0.6, 0.2, 1.5)',
      style({
        transform: 'scale(0.5)',
        opacity: 0,
        maxHeight: 0,
        marginBottom: 0,
      })
    ),
  ]),
]);

export const listTrigger = trigger('list', [
  transition(':enter', [
    query('@items', stagger(50, animateChild()), { optional: true, delay: 0 }),
  ]),
]);
